export default __webpack_public_path__ + "static/media/BIRTH-CONTROL.59788c8a.png";